import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV === 'development') {
      console.error('ErrorBoundary caught:', error, info.componentStack);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#F4F6F8',
          padding: '2rem',
          textAlign: 'center',
        }}>
          <img
            src="/gameplannr-logo.png"
            alt="GamePlannr"
            style={{ height: '48px', marginBottom: '1.5rem' }}
          />
          <h1 style={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: '800',
            color: '#0D1B2A',
            fontSize: '1.75rem',
            marginBottom: '0.75rem',
          }}>
            Something went wrong
          </h1>
          <p style={{
            fontFamily: 'Open Sans, sans-serif',
            color: '#1A1A2E',
            marginBottom: '2rem',
            maxWidth: '400px',
          }}>
            We hit an unexpected error. Don't worry — your data is safe. Try going back home or refreshing the page.
          </p>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre style={{
              textAlign: 'left',
              background: '#fff',
              border: '1px solid #D32F2F',
              borderRadius: '8px',
              padding: '1rem',
              marginBottom: '1.5rem',
              maxWidth: '700px',
              width: '100%',
              overflow: 'auto',
              fontSize: '0.78rem',
              color: '#D32F2F',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}>
              {this.state.error.message}
              {'\n\n'}
              {this.state.error.stack}
            </pre>
          )}
          <a
            href="/"
            style={{
              backgroundColor: '#3ED7C6',
              color: '#0D1B2A',
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: '700',
              padding: '0.75rem 1.75rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '1rem',
            }}
          >
            Go Home
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
